"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWrapper = exports.ContentDescription = exports.ContentText = exports.ContentTitle = exports.ContentWrapper = exports.HeaderIconWrapper = exports.ModalContent = exports.BackDrop = exports.Wrapper = void 0;
const react_native_1 = require("react-native");
const native_1 = __importDefault(require("styled-components/native"));
const BottomTrayModalTypes_1 = require("./BottomTrayModalTypes");
const getColorFromType = (type, theme) => {
    switch (type) {
        case BottomTrayModalTypes_1.BottomTrayModalType.ARAL:
        case BottomTrayModalTypes_1.BottomTrayModalType.PULSE:
            return theme.bpCore.colors.primary[500];
        case BottomTrayModalTypes_1.BottomTrayModalType.ERROR:
            return theme.bpCore.colors.error;
        case BottomTrayModalTypes_1.BottomTrayModalType.SUCCESS:
            return theme.bpCore.colors.success;
        default:
            return theme.bpCore.colors.primary[500];
    }
};
exports.Wrapper = native_1.default.View `
  position: ${react_native_1.Platform.OS === 'web' ? 'fixed' : 'absolute'};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  z-index: 999;
`;
exports.BackDrop = native_1.default.View `
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
  background-color: rgba(0, 0, 0, 0.5);
`;
exports.ModalContent = native_1.default.View `
  width: 100%;
  background-color: #fff;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;
exports.HeaderIconWrapper = native_1.default.View `
  display: flex;
  position: absolute;
  left: 50%;
  margin-top: -26px;
  margin-left: -26px;
  background-color: ${({ type, theme }) => getColorFromType(type, theme)};
  padding: 10px;
  border: 8px solid ${({ theme }) => theme.bpCore.colors.white};
  border-radius: 100px;
`;
exports.ContentWrapper = native_1.default.View `
  padding: 32px 16px 16px 16px;
`;
exports.ContentTitle = native_1.default.Text `
  color: ${({ theme, titleSize }) => titleSize === BottomTrayModalTypes_1.BottomTrayTitleSize.SMALL
    ? theme.bpCore.colors.neutral[800]
    : theme.bpCore.colors.primary[500]};
  font-family: ${({ theme }) => theme.bpCore.typography.heading1.fontFamily};
  font-size: ${({ titleSize }) => titleSize === BottomTrayModalTypes_1.BottomTrayTitleSize.SMALL ? '18px' : '22px'};
  ${({ titleSize }) => titleSize === BottomTrayModalTypes_1.BottomTrayTitleSize.SMALL && 'line-height: 20px;'}
  margin-top: 8px;
  margin-bottom: ${({ contentMarginBottom }) => contentMarginBottom}
  text-align: center;
`;
exports.ContentText = native_1.default.Text `
  color: ${({ theme, titleSize }) => theme.bpCore.colors.neutral[titleSize === BottomTrayModalTypes_1.BottomTrayTitleSize.SMALL ? 800 : 600]};
  font-size: ${({ titleSize }) => titleSize === BottomTrayModalTypes_1.BottomTrayTitleSize.SMALL ? '18px' : '14px'};
  ${({ theme, titleSize }) => titleSize === BottomTrayModalTypes_1.BottomTrayTitleSize.SMALL &&
    `font-family: ${theme.bpCore.typography.heading1.fontFamily};`}
  line-height: 24px;
  margin-bottom: ${({ contentMarginBottom }) => contentMarginBottom}
  text-align: center;
`;
exports.ContentDescription = native_1.default.Text `
  color: ${({ theme }) => theme.bpCore.colors.neutral[500]};
  font-size: ${({ titleSize }) => titleSize === BottomTrayModalTypes_1.BottomTrayTitleSize.SMALL ? '14px' : '12px'};
  text-align: ${({ contentTextAlign }) => contentTextAlign};
  margin-bottom: ${({ contentMarginBottom }) => contentMarginBottom}
    ${({ titleSize }) => titleSize !== BottomTrayModalTypes_1.BottomTrayTitleSize.SMALL && 'line-height: 19px;'};
`;
exports.ButtonWrapper = native_1.default.View `
  margin-top: 16px;
  margin-bottom: 24px;
`;
